/* eslint-disable consistent-return */
import React, { Component } from "react"
import PropTypes from "prop-types"
import { select } from "d3-selection"

class StackedBarChartViz extends Component {
  componentDidMount() {
    this.drawChart()
  }

  componentDidUpdate() {
    this.drawChart(true)
  }

  drawChart(update = false) {
    const { x, z, h, series } = this.props

    // Resetting bars for update
    if (update) {
      select(this.g)
        .selectAll("g.bar")
        .remove()
    }

    // Parent Element
    const g = select(this.g)

    // Groups
    const groups = g
      .selectAll("g.bar")
      .data(series)
      .enter()
      .append("g")
      .attr("class", "bar")
      .attr("fill", d => z(d.key))

    // Rectangles
    groups
      .selectAll("rect")
      .data(d => d)
      .enter()
      .append("rect")
      .attr("x", d => x(d[1]))
      .attr("y", 5)
      .attr("height", h)
      .attr("width", d => x(d[0]) - x(d[1]))
      .attr("clip-path", "url(#horizontal-stacked-bar)")

    // Labels
    groups
      .selectAll("text")
      .data(d => d)
      .enter()
      .append("text")
      .attr("x", d => x(d[1]))
      .attr("y", 0)
      .text(d => {
        const percentage = Math.round((d[1] - d[0]) * 100)
        if (percentage !== 0) return `${percentage}%`
      })
      .attr("font-size", 12)
      .attr("font-weight", "bold")
  }

  render() {
    const {
      svgWidth,
      svgHeight,
      margin: { left, top },
      w,
      h
    } = this.props

    return (
      <svg
        width={svgWidth}
        height={svgHeight}
        className="horizontal-stacked-bar"
      >
        <g
          ref={e => {
            this.g = e
          }}
          transform={`translate(${left}, ${top})`}
        >
          <clipPath id="horizontal-stacked-bar">
            <rect x={0} y={5} width={w} height={h - 10} rx="3" ry="3" />
          </clipPath>
        </g>
      </svg>
    )
  }
}

export default StackedBarChartViz

StackedBarChartViz.propTypes = {
  x: PropTypes.func.isRequired,
  z: PropTypes.func.isRequired,
  h: PropTypes.number.isRequired,
  w: PropTypes.number.isRequired,
  series: PropTypes.arrayOf(PropTypes.array).isRequired,
  svgWidth: PropTypes.number.isRequired,
  svgHeight: PropTypes.number.isRequired,
  margin: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  }).isRequired
}
